export const OFFSET_LIMIT = 40;

export const gameFilters = {
  ALL_GAMES: 'All Games',
  FAVORITES: 'Favorites',
};

export const GAMES_URL = {
  0: 'https://{url}/?gameID={game}&partnerID=1598&play={mode}',
  1: 'https://{url}/?partnerId=999&gameId={game}&gameMode=fun&lang={lang}&platform=1&play={mode}',
  2: 'https://{url}/block-chain/?gameId={game}&play={mode}',
};
